import { defineComponent as _defineComponent } from 'vue';
import { withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref, isRef as _isRef, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = { class: "rec-selector-menu__scroll" };
const _hoisted_2 = {
    key: 2,
    class: "rec-selector-menu__empty"
};
import { computed, ref } from "vue";
import { useVModel } from "@vueuse/core";
// Components
import SelectorOptionHeader from "./SelectorOptionHeader.vue";
import SelectOption from "./SelectorOption.vue";
import SearchInput from "@/common/components/SearchInput.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'SelectorMenu',
    props: {
        modelValue: {},
        options: {},
        multiple: { type: Boolean },
        disabled: { type: Boolean },
        style: { type: [Boolean, null, String, Object, Array] },
        menuToggleBtn: {}
    },
    setup(__props) {
        const props = __props;
        const model = useVModel(props, "modelValue");
        const optionsSearchTerm = ref("");
        const optionsCount = computed(() => props.options.reduce((acc, option) => {
            if ("options" in option) {
                return acc + option.options.length;
            }
            if ("header" in option) {
                return acc;
            }
            return acc + 1;
        }, 0));
        const filteredOptions = computed(() => {
            return props.options
                .filter((option) => {
                if ("options" in option) {
                    return option.options?.some((opt) => opt.name.toLowerCase().includes(optionsSearchTerm.value.toLowerCase()));
                }
                if ("header" in option) {
                    return true; // Always include headers
                }
                return (!option.name ||
                    option.name.toLowerCase().includes((optionsSearchTerm.value ?? "").toLowerCase()));
            })
                .flatMap((option) => {
                if ("options" in option) {
                    return [
                        { header: option.header },
                        ...option.options.filter((opt) => opt.name.toLowerCase().includes(optionsSearchTerm.value.toLowerCase()))
                    ];
                }
                return [option];
            });
        });
        const hoveredOption = ref();
        const hover = (option) => {
            if (option && option.id !== model.value?.id) {
                hoveredOption.value = option;
            }
        };
        const unhover = (option) => {
            if (hoveredOption.value && hoveredOption.value.id == option.id) {
                hoveredOption.value = undefined;
            }
        };
        const menuRoot = ref();
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                ref_key: "menuRoot",
                ref: menuRoot,
                style: _normalizeStyle(_ctx.style),
                class: "rec-selector-menu",
                role: "menu",
                "aria-expanded": "true",
                onClick: _cache[4] || (_cache[4] = _withModifiers(() => { }, ["stop"]))
            }, [
                _createElementVNode("div", _hoisted_1, [
                    (optionsCount.value > 20)
                        ? (_openBlock(), _createBlock(SearchInput, {
                            key: 0,
                            modelValue: optionsSearchTerm.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((optionsSearchTerm).value = $event)),
                            "update-on-input": true,
                            class: "rec-selector-menu__search",
                            placeholder: _ctx.$t('Search'),
                            onClick: _cache[1] || (_cache[1] = _withModifiers(() => { }, ["stop"]))
                        }, null, 8, ["modelValue", "placeholder"]))
                        : _createCommentVNode("", true),
                    (filteredOptions.value.length > 0)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(filteredOptions.value, (option, idx) => {
                            return (_openBlock(), _createElementBlock(_Fragment, { key: idx }, [
                                ('header' in option)
                                    ? (_openBlock(), _createBlock(SelectorOptionHeader, {
                                        key: 0,
                                        header: option,
                                        "break-required": idx > 0
                                    }, null, 8, ["header", "break-required"]))
                                    : (option.condensed && option.subOptions)
                                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(option.subOptions, (subOption) => {
                                            return (_openBlock(), _createBlock(SelectOption, {
                                                key: option.id + '_' + subOption.id,
                                                modelValue: _unref(model),
                                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => (_isRef(model) ? (model).value = $event : null)),
                                                "parent-option": option,
                                                multiple: _ctx.multiple,
                                                option: subOption,
                                                "hovered-option": hoveredOption.value,
                                                "parent-menu": menuRoot.value,
                                                "menu-toggle-btn": _ctx.menuToggleBtn,
                                                onHover: hover,
                                                onUnhover: unhover
                                            }, null, 8, ["modelValue", "parent-option", "multiple", "option", "hovered-option", "parent-menu", "menu-toggle-btn"]));
                                        }), 128))
                                        : (_openBlock(), _createBlock(SelectOption, {
                                            key: 2,
                                            modelValue: _unref(model),
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => (_isRef(model) ? (model).value = $event : null)),
                                            multiple: _ctx.multiple,
                                            option: option,
                                            "hovered-option": hoveredOption.value,
                                            "parent-menu": menuRoot.value,
                                            "menu-toggle-btn": _ctx.menuToggleBtn,
                                            onHover: hover,
                                            onUnhover: unhover
                                        }, null, 8, ["modelValue", "multiple", "option", "hovered-option", "parent-menu", "menu-toggle-btn"]))
                            ], 64));
                        }), 128))
                        : (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.$t("Nothing to display")), 1))
                ])
            ], 4));
        };
    }
});
